/**
 * External dependencies
 */
import React from 'react';

/**
 * Icon component.
 *
 * @param {string} classes List of classes
 * @return {*} Icon component.
 * @class
 */
export default function Icon( { classes } ) {
	return <span className={ classes } aria-hidden="true" />;
}
